import React from "react";

import { Avatar, Box, Typography } from "@mui/material";

export const ManagerAvatar = ({
  managerPhotoUrl,
  managerInitials,
  isAdmin,
}: {
  managerPhotoUrl?: string;
  managerInitials: string;
  isAdmin?: boolean;
}) => (
  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
    <Avatar
      sx={({ palette }) => ({
        bgcolor: palette.primary.main,
        ...(isAdmin && {
          border: `2px solid ${palette.secondary.main}`,
        }),
      })}
    >
      {managerPhotoUrl ? (
        <img
          src={managerPhotoUrl}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      ) : (
        managerInitials
      )}
    </Avatar>
    {isAdmin && (
      <Typography
        sx={({ palette }) => ({
          fontSize: 9,
          fontWeight: 600,
          color: palette.secondary.main,
          letterSpacing: 0.5,
          mt: 0.25,
          lineHeight: 1,
        })}
      >
        Admin
      </Typography>
    )}
  </Box>
);
